var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Ember from 'ember';
import Service, { inject as service } from '@ember/service';
import { readOnly, reads, not } from '@ember/object/computed';
import { computed, set } from '@ember/object';
import { feature } from '@square/ember-features/macros';
let EmployeeInfo = (_dec = readOnly('currentEmployeeData.data'), _dec2 = feature('timecards/hide_wage_permission'), _dec3 = reads('data.isOwner'), _dec4 = reads('data.employmentToken'), _dec5 = reads('data.isAccountOwner'), _dec6 = computed('_isEmployee', 'employmentToken'), _dec7 = not('isOwner'), _dec8 = reads('data.permissions'), _dec9 = reads('permissions.canEmployeeAccessAppointments'), _dec10 = reads('permissions.canEmployeeSeeAppointmentsUpsell'), _dec11 = reads('permissions.canEmployeeDashboardManageBusinessProfile'), _dec12 = reads('permissions.canEmployeeDashboardManageBankAccounts'), _dec13 = reads('permissions.canEmployeeDashboardViewCustomers'), _dec14 = computed('_shouldShowLoyaltyAccounts', 'permissions.{canEmployeeDashboardViewCustomers,canViewLoyaltyAccounts}'), _dec15 = reads('permissions.canEmployeeDashboardManageSubscriptions'), _dec16 = reads('permissions.canEmployeeDashboardManageDevices'), _dec17 = reads('permissions.canEmployeeDashboardIssueRefunds'), _dec18 = reads('permissions.canEmployeeDashboardManageInstrumentsOnFile'), _dec19 = reads('permissions.canEmployeeDashboardManageCustomerImportExportAndCustomFields'), _dec20 = reads('permissions.canEmployeeDashboardManageInvoices'), _dec21 = reads('permissions.canEmployeeDashboardViewExpectedInDrawer'), _dec22 = reads('permissions.canEmployeeDashboardManageDevices'), _dec23 = reads('permissions.canEmployeeDashboardManageItems'), _dec24 = reads('permissions.canEmployeeDashboardManageServiceSettings'), _dec25 = reads('permissions.canEmployeeDashboardManageCashDrawers'), _dec26 = reads('permissions.canEmployeeDashboardManageLocations'), _dec27 = reads('permissions.canEmployeeDashboardViewActivityReports'), _dec28 = reads('permissions.canManageCommissionSettings'), _dec29 = reads('permissions.canManageContracts'), _dec30 = reads('permissions.canEmployeeDashboardManageCustomerCampaigns'), _dec31 = reads('permissions.canEmployeeDashboardManageEmployees'), _dec32 = reads('permissions.canManageSchedules'), _dec33 = reads('permissions.canManageScheduleRequests'), _dec34 = reads('permissions.canHouseAccountsRead'), _dec35 = reads('permissions.canHouseAccountsWrite'), _dec36 = reads('permissions.canCustomerCardonfileRead'), _dec37 = reads('permissions.canCustomerCardonfileCreate'), _dec38 = reads('permissions.canCustomerCardonfileDelete'), _dec39 = reads('permissions.canCustomerContactInfoRead'), _dec40 = reads('permissions.canCustomerCreate'), _dec41 = reads('permissions.canCustomerDirectoryAccess'), _dec42 = reads('permissions.canCustomerUpdate'), _dec43 = reads('permissions.canCustomerExport'), _dec44 = reads('permissions.canManageTipDistributionSettings'), _dec45 = reads('permissions.canManageAdvancedSalesReportFilters'), _dec46 = computed('permissions.canAllowViewWageInformation', 'canUseHideWagePermission'), _dec47 = computed('data.backupRoute', 'isEmployee', 'permissions.{canEmployeeAccessAppointments,canEmployeeDashboardManageBusinessProfile,canEmployeeDashboardManageDevices,canEmployeeDashboardManageDisputes,canEmployeeDashboardManageEmployees,canEmployeeDashboardManageItems,canEmployeeDashboardManageSubscriptions,canEmployeeDashboardManageTimecards,canEmployeeDashboardViewActivityReports,canEmployeeDashboardViewCashDrawerReports,canEmployeeDashboardViewCustomers,canEmployeeDashboardViewSalesReports,canEmployeeDashboardViewTransactions,canEmployeeViewDetailedSalesReports,canManageSalesTax,canManageSchedules,canManageTipDistributionSettings,canViewInventoryReports}'), _class = class EmployeeInfo extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentEmployeeData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _initializerDefineProperty(this, "canUseHideWagePermission", _descriptor3, this);
    _initializerDefineProperty(this, "isOwner", _descriptor4, this);
    _initializerDefineProperty(this, "employmentToken", _descriptor5, this);
    _initializerDefineProperty(this, "isAccountOwner", _descriptor6, this);
    _defineProperty(this, "_isEmployee", void 0);
    _initializerDefineProperty(this, "isNotOwner", _descriptor7, this);
    _initializerDefineProperty(this, "permissions", _descriptor8, this);
    _initializerDefineProperty(this, "shouldShowAppointments", _descriptor9, this);
    _initializerDefineProperty(this, "shouldShowAppointmentsUpsell", _descriptor10, this);
    _initializerDefineProperty(this, "shouldShowBusinessProfile", _descriptor11, this);
    _initializerDefineProperty(this, "shouldShowBankAccounts", _descriptor12, this);
    _initializerDefineProperty(this, "shouldShowCustomers", _descriptor13, this);
    _defineProperty(this, "_shouldShowLoyaltyAccounts", void 0);
    _initializerDefineProperty(this, "shouldShowSubscriptions", _descriptor14, this);
    _initializerDefineProperty(this, "shouldShowDevices", _descriptor15, this);
    _initializerDefineProperty(this, "shouldEnableIssueRefunds", _descriptor16, this);
    _initializerDefineProperty(this, "shouldShowInstrumentsOnFile", _descriptor17, this);
    _initializerDefineProperty(this, "shouldManageCustomerImportExportAndCustomFields", _descriptor18, this);
    _initializerDefineProperty(this, "shouldManageInvoices", _descriptor19, this);
    _initializerDefineProperty(this, "shouldShowExpectedInDrawer", _descriptor20, this);
    _initializerDefineProperty(this, "shouldShowManageDevices", _descriptor21, this);
    _initializerDefineProperty(this, "shouldShowManageItems", _descriptor22, this);
    _initializerDefineProperty(this, "shouldShowManageServiceSettings", _descriptor23, this);
    _initializerDefineProperty(this, "canManageCashDrawers", _descriptor24, this);
    _initializerDefineProperty(this, "canManageLocations", _descriptor25, this);
    _initializerDefineProperty(this, "canViewActivityReports", _descriptor26, this);
    _initializerDefineProperty(this, "canManageCommissionSettings", _descriptor27, this);
    _initializerDefineProperty(this, "canManageContracts", _descriptor28, this);
    _initializerDefineProperty(this, "canManageCustomerCampaigns", _descriptor29, this);
    _initializerDefineProperty(this, "canManageEmployees", _descriptor30, this);
    _initializerDefineProperty(this, "canManageSchedules", _descriptor31, this);
    _initializerDefineProperty(this, "canManageScheduleRequests", _descriptor32, this);
    _initializerDefineProperty(this, "canViewHouseAccounts", _descriptor33, this);
    _initializerDefineProperty(this, "canEditHouseAccounts", _descriptor34, this);
    _initializerDefineProperty(this, "canReadCardOnFile", _descriptor35, this);
    _initializerDefineProperty(this, "canCreateCardOnFile", _descriptor36, this);
    _initializerDefineProperty(this, "canDeleteCardOnFile", _descriptor37, this);
    _initializerDefineProperty(this, "canCustomerContactInfoRead", _descriptor38, this);
    _initializerDefineProperty(this, "canCustomerCreate", _descriptor39, this);
    _initializerDefineProperty(this, "canCustomerDirectoryAccess", _descriptor40, this);
    _initializerDefineProperty(this, "canCustomerUpdate", _descriptor41, this);
    _initializerDefineProperty(this, "canCustomerExport", _descriptor42, this);
    _initializerDefineProperty(this, "canManageTipDistributionSettings", _descriptor43, this);
    _initializerDefineProperty(this, "canManageAdvancedSalesReportFilters", _descriptor44, this);
  }
  get isEmployee() {
    if (this._isEmployee !== undefined) {
      return this._isEmployee;
    }
    return Boolean(this.employmentToken);
  }
  set isEmployee(value) {
    set(this, '_isEmployee', value);
  }
  get shouldShowLoyaltyAccounts() {
    if (this._shouldShowLoyaltyAccounts !== undefined) {
      return this._shouldShowLoyaltyAccounts;
    }
    return this.permissions?.canEmployeeDashboardViewCustomers || this.permissions?.canViewLoyaltyAccounts;
  }
  set shouldShowLoyaltyAccounts(value) {
    set(this, '_shouldShowLoyaltyAccounts', value);
  }
  get canViewWagesInShifts() {
    return !this.canUseHideWagePermission || this.permissions.canAllowViewWageInformation;
  }
  get backupRoute() {
    // A handful of tests add this override and it's hard to do it in a better way
    if (Ember.testing && this.data.backupRoute) {
      return this.data.backupRoute;
    }
    if (!this.isEmployee || this.permissions?.canEmployeeDashboardViewSalesReports) {
      return 'index';
    }
    if (this.permissions?.canEmployeeDashboardManageItems) {
      return 'items';
    }
    if (this.permissions?.canEmployeeDashboardManageEmployees) {
      return 'team';
    }
    if (this.permissions?.canEmployeeAccessAppointments) {
      return 'appointments';
    }
    if (this.permissions?.canEmployeeDashboardViewCustomers) {
      return 'customers';
    }
    // TODO: When invoices stops depending on the customers permission, enabled this
    // if (this.get('permissions.canEmployeeDashboardManageInvoices')) {
    //   return 'invoices';
    // }
    if (this.permissions?.canEmployeeDashboardManageTimecards || this.permissions?.canManageSchedules || this.permissions?.canManageTipDistributionSettings) {
      return 'shifts';
    }
    if (this.permissions?.canEmployeeDashboardManageSubscriptions) {
      return 'user_settings.subscriptions';
    }
    if (this.permissions?.canEmployeeDashboardManageBusinessProfile) {
      return 'business.identities.receipt';
    }
    if (this.permissions?.canEmployeeDashboardManageDevices) {
      return 'business.devices';
    }
    if (this.permissions?.canManageSalesTax) {
      return 'business.manual-taxes';
    }
    return 'user_settings';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentEmployeeData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canUseHideWagePermission", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isOwner", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "employmentToken", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isAccountOwner", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isEmployee", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "isEmployee"), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isNotOwner", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "permissions", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAppointments", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAppointmentsUpsell", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "shouldShowBusinessProfile", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "shouldShowBankAccounts", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "shouldShowCustomers", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "shouldShowLoyaltyAccounts", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowLoyaltyAccounts"), _class.prototype), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "shouldShowSubscriptions", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "shouldShowDevices", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "shouldEnableIssueRefunds", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "shouldShowInstrumentsOnFile", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "shouldManageCustomerImportExportAndCustomFields", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "shouldManageInvoices", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "shouldShowExpectedInDrawer", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "shouldShowManageDevices", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "shouldShowManageItems", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "shouldShowManageServiceSettings", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "canManageCashDrawers", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "canManageLocations", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "canViewActivityReports", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "canManageCommissionSettings", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "canManageContracts", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "canManageCustomerCampaigns", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "canManageEmployees", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "canManageSchedules", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "canManageScheduleRequests", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "canViewHouseAccounts", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "canEditHouseAccounts", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "canReadCardOnFile", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "canCreateCardOnFile", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "canDeleteCardOnFile", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "canCustomerContactInfoRead", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "canCustomerCreate", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "canCustomerDirectoryAccess", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "canCustomerUpdate", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "canCustomerExport", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "canManageTipDistributionSettings", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "canManageAdvancedSalesReportFilters", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canViewWagesInShifts", [_dec46], Object.getOwnPropertyDescriptor(_class.prototype, "canViewWagesInShifts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backupRoute", [_dec47], Object.getOwnPropertyDescriptor(_class.prototype, "backupRoute"), _class.prototype), _class);
export { EmployeeInfo as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.